<template>
<div class="col-2" @click="detectOutside">
<div class="content_card_content right_panel">
<div class="flex justify-content-between flex-wrap align-items-center">
<h4 class="text-primary my-0">Ayarlar</h4>
</div>
<hr/>


<template v-if="selected_item">
<div class="grid">
<!-- name -->
<div class="col-12">
<template v-if="editing">
<div  v-click-away="endEditing" >
<InputText  type="text" v-model="selected_item.name" class="w-full p-inputtext-sm animate_class"  v-on:keyup.enter="endEditing"    />
</div>
</template>
<template v-if="!editing">
<p class="text-primary py-1 my-0 name_selector "  @dblclick="edit" >{{selected_item.name}}</p>
</template>
</div>
<!-- name -->

<!-- grid -->
<template v-if="selected_item.type=='grid'">
<div class="col-8">
<div class="grid">
<div class="col-4">
<div class="flex justify-content-center flex-wrap">
<Button icon="pi pi-minus" class=" p-button-primary p-button-outlined  p-button-sm tetest" @click="dicreaseGridBlocks"></Button>
</div>
</div>
<div class="col-4">
<div class="flex justify-content-center flex-wrap">
<h3 class="text-primary my-0 text-center  ">{{gridblockscount}}</h3>
</div>
</div>
<div class="col-4">
<div class="flex justify-content-center flex-wrap">
<Button icon="pi pi-plus" class=" p-button-primary p-button-outlined  p-button-sm tetest" @click="increaseGridBlocks"></Button>
</div>
</div>
</div>
</div>
</template>
<!-- grid -->


</div>
</template>



</div>
</div>
</template>

<script>
export default {

  name: 'SchemaEditorConfigs',

  data () {
    return {
    	selected_item:null,
    	editing:false,
      gridblockscount:1,
    }
  },
  watch:{
  	selected_element(newval,oldval)
    {
      this.selected_item = this.$store.state.customresultdisplays.selected_element
      if(this.selected_item)
      {
        this.gridblockscount = this.selected_item.elements.length
      }
      
    },
  },
  computed:{
  	selected_element()
    {
      return this.$store.state.customresultdisplays.selected_element
    },
  },
  methods:{
    dicreaseGridBlocks()
    {
      if(this.gridblockscount===1)
      {

      }
      else
      {
        this.gridblockscount--
      }
      
    },
    increaseGridBlocks()
    {
      this.gridblockscount++
    },
  	edit()
  	{
  		this.editing = true
  	},
  	endEditing()
  	{
  		this.editing = false
  	},
    detectOutside(event)
    {
      if(!event.target.closest('.right_panel')) 
      {
         this.endEditing()
      }
    }
  }
}
</script>

<style lang="css" scoped>
.right_panel{
	min-height: 200px;
}

</style>